// Google Analytics 4 Setup for Datenite
// Replace 'GA_MEASUREMENT_ID' with your actual Google Analytics 4 Measurement ID

export const GA_MEASUREMENT_ID = 'G-XXXXXXXXXX'; // Replace with your GA4 ID

// Initialize Google Analytics
export const initializeGA = () => {
  // Load Google Analytics script
  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script1);

  // Initialize gtag
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;

  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID, {
    // Disable automatic page view tracking - we'll do it manually
    send_page_view: false,
    // Anonymize IP addresses for privacy
    anonymize_ip: true,
  });

  console.log('✅ Google Analytics initialized');
};

// Track page views manually (call this when analytics cookies are accepted)
export const trackPageView = (path) => {
  if (window.gtag) {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: path,
    });
  }
};

// Track custom events
export const trackEvent = (eventName, parameters = {}) => {
  if (window.gtag) {
    window.gtag('event', eventName, parameters);
  }
};

// Track cookie consent specifically
export const trackCookieConsent = (action, accepted = false) => {
  if (window.gtag) {
    window.gtag('event', 'cookie_consent', {
      event_category: 'Privacy',
      event_label: action, // 'Accept All Cookies' or 'Reject All Cookies'
      value: accepted ? 1 : 0,
      custom_parameters: {
        consent_type: accepted ? 'accepted' : 'rejected',
        timestamp: new Date().toISOString(),
      }
    });
    
    console.log(`📊 Tracked cookie consent: ${action}`);
  }
};
